import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useAccountsStore } from "@stores/accounts";
import { useMCampaignsStore } from "@stores/mCampaigns";
import { createFilters } from "@/utils/composables/filters/createFilters";

export const useMCampaignsFilters = () => {
  const accountsStore = useAccountsStore();
  const mCampaignsStore = useMCampaignsStore();

  const { accounts } = storeToRefs(accountsStore);
  const { surveysStatusFilter, mCampaignsStatusFilter, surveysAccountsFilter } = storeToRefs(mCampaignsStore);
  const { clearFilters, search } = mCampaignsStore;

  const accountOptions = computed(() => accounts.value?.map(({ name, id }) => ({ label: name, value: id })) || []);

  return createFilters({
    filters: [
      {
        id: "surveyStatus",
        label: "Survey status",
        options: [
          { label: "Draft", value: "draft" },
          { label: "Review", value: "review" },
          { label: "Live", value: "live" },
          { label: "Paused", value: "paused" },
          { label: "Complete", value: "complete" },
        ],
        model: surveysStatusFilter,
      },
      {
        id: "campaignStatus",
        label: "Campaign status",
        options: [
          { label: "On", value: "active" },
          { label: "Off", value: "inactive" },
        ],
        model: mCampaignsStatusFilter,
      },
      {
        id: "accounts",
        label: "Account",
        hasSearch: true,
        options: accountOptions,
        model: surveysAccountsFilter,
      },
    ],
    search,
    clear: clearFilters,
  });
};
